import styles from './MainReviewFrame.module.scss';
import star from '../../assets/star.png';
import emptyStar from '../../assets/emptyStar.png';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function MainReviewFrame(props: { review: IReviewDataType }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.reviewImageWrap}>
        <img
          src={
            props.review.images[0]
              ? props.review.images[0].image + '?w=400'
              : props.review.product.list_image + '?w=400'
          }
          alt="reviewImg"
        />
      </div>
      <p className={styles.reviewContent}>{props.review.content}</p>
      <hr className={styles.separator} />
      <div className={styles.infoWrap}>
        <div className={styles.thumbnailWrap}>
          <img
            src={props.review.product.list_image + '?w=200'}
            alt="productThumbnail"
          />
        </div>
        <div className={styles.userInfoWrap}>
          <span className={styles.userId}>
            {props.review.member_id.substring(0, 15)}
          </span>
          <span className={styles.userInfo}>
            {props.review.age}s /{' '}
            {props.review.gender === 'F'
              ? t('productDetail.37')
              : t('productDetail.36')}
          </span>
          <div className={styles.reviewScore}>
            {(() => {
              const list: boolean[] = [];
              for (let i = 1; i <= 5; i++) {
                if (
                  i <=
                  Math.round(
                    (props.review.stars0 +
                      props.review.stars1 +
                      props.review.stars2 +
                      props.review.stars3) /
                      4 /
                      20,
                  )
                )
                  list.push(true);
                else list.push(false);
              }
              return list.map((isTrue, idx) => (
                <img
                  key={idx}
                  src={isTrue ? star : emptyStar}
                  alt="star"
                />
              ));
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainReviewFrame;
